<template>
    <StepModal
        ref="stepModal"
        :title="$t('labels.connectIntegrationProducts')"
        :steps="steps"
        @submit="submit"
        @on-hide="reset"
    />
</template>
<script>
import StepModal from "../../../../components/new/modal/StepModal.vue";
import ProductsSelectionStep from "../compare/ProductsSelectionStep.vue";
import MatchesReviewStep from "./MatchesReviewStep.vue";
import TypesSelectionStep from "./TypesSelectionStep.vue";
import StockAndPriceStep from "./StockAndPriceStep.vue";

import { httpClient } from "../../../../services/HttpClient";

export default {
    name: 'ConnectPublicationsModal',
    components: {
        StepModal, ProductsSelectionStep, MatchesReviewStep, TypesSelectionStep, StockAndPriceStep
    },
    emits: ['closed'],
    data() {
        return {
            selectedUuids: [],
            filters: {},
            isAllSelected: false,
            totalProducts: 0,
            selectionMode: null,
            selectedProducts: {},
            selectedTypes: {},
            warehouse: null,
            supplier: null,
            priceCustomField: null,
            onlyMatched: false,
        }
    },
    methods: {
        show(selectedUuids, filters, isAllSelected, totalProducts) {
            this.selectedUuids = selectedUuids;
            this.filters = filters;
            this.isAllSelected = isAllSelected;
            this.totalProducts = totalProducts;
            this.selectionMode = selectedUuids.length > 0 ? { value: 'selected' } : { value: 'all' };

            this.$refs.stepModal.show();
        },
        reset() {
            this.$refs.stepModal.reset();
            this.selectedUuids = [];
            this.filters = {};
            this.isAllSelected = false;
            this.totalProducts = 0;
            this.selectionMode = null;
            this.selectedProducts = {};
            this.selectedTypes = {};
            this.warehouse = null;
            this.supplier = null;
            this.priceCustomField = null;
            this.onlyMatched = false;
            this.$emit('closed');
        },
        async submit() {
            const { projectUuid, integrationUuid } = this.$route.params;

            await httpClient.post(
                `/projects/${projectUuid}/pim/channels/${integrationUuid}/connection-process/execute`,
                this.executePayload,
            );

            this.$refs.stepModal.hide();
        }
    },
    computed: {
        executePayload() {
            const payload = {};

            const categoryAndTypeMatch = Object.entries(this.selectedTypes)
                .filter(([, type]) => type)
                .map(([categoryUuid, type]) => ({ category_uuid: categoryUuid, type_uuid: type.uuid }));
            if (categoryAndTypeMatch.length > 0) {
                payload.category_and_type_match = categoryAndTypeMatch;
            }

            if (this.warehouse) {
                payload.warehouse_uuid = this.warehouse.uuid;
            }

            if (this.supplier) {
                payload.supplier_uuid = this.supplier.uuid;
            }

            if (this.priceCustomField) {
                payload.price_custom_field_uuid = this.priceCustomField.uuid;
            }

            payload.only_matched = this.onlyMatched;

            const matches = Object.entries(this.selectedProducts)
                .filter(([, product]) => product)
                .map(([publicationUuid, product]) => ({ publication_uuid: publicationUuid, product_uuid: product.uuid }));
            if (matches.length > 0) {
                payload.matches = matches;
            }

            return payload;
        },
        steps() {
            return [
                {
                    component: ProductsSelectionStep,
                    description: this.$t('labels.connect_integration_products_select_step_description'),
                    props: {
                        selectedProductsCount: this.selectedUuids.length,
                        totalProductsCount: this.totalProducts,
                        modelValue: this.selectionMode,
                        'onUpdate:modelValue': (val) => { this.selectionMode = val; },
                    },
                },
                {
                    component: MatchesReviewStep,
                    description: this.$t('labels.connect_integration_products_match_step_description'),
                    size: 'full',
                    props: {
                        selectionMode: this.selectionMode,
                        selectedUuids: this.selectedUuids,
                        filters: this.filters,
                        selectedProducts: this.selectedProducts,
                        'onUpdate:selectedProducts': (val) => { this.selectedProducts = val; },
                    },
                },
                {
                    component: TypesSelectionStep,
                    description: this.$t('labels.connect_integration_products_types_step_description'),
                    size: 'full',
                    props: {
                        selectionMode: this.selectionMode,
                        selectedUuids: this.selectedUuids,
                        filters: this.filters,
                        selectedTypes: this.selectedTypes,
                        'onUpdate:selectedTypes': (val) => { this.selectedTypes = val; },
                    },
                },
                {
                    component: StockAndPriceStep,
                    description: this.$t('labels.connect_integration_products_stock_price_step_description'),
                    props: {
                        warehouse: this.warehouse,
                        'onUpdate:warehouse': (val) => { this.warehouse = val; },
                        supplier: this.supplier,
                        'onUpdate:supplier': (val) => { this.supplier = val; },
                        priceCustomField: this.priceCustomField,
                        'onUpdate:priceCustomField': (val) => { this.priceCustomField = val; },
                        onlyMatched: this.onlyMatched,
                        'onUpdate:onlyMatched': (val) => { this.onlyMatched = val; },
                    },
                },
            ];
        }
    }
}
</script>
